import React, { useState } from 'react';
import styled from 'styled-components';
import { CustomerQueues } from './customer-queues';
import { Consent } from './consent';
import TimeAgo from 'react-timeago';
import { Customer } from '../../../types/models/customer';
import { ConfirmModal } from '../../../components/confirm-modal';
import { deleteCustomer } from '../../../api/index';
import { Icon } from 'semantic-ui-react';
import { baseColors } from '../../../themes/colors';
import { dateFormats } from '@nextinq/domain';

const CustomerStyle = styled.div`
  display: grid;
  grid-template-columns: 100px 1fr;
  width: 600px;
  font-size: 1.1em;
  padding: 0.5em;
`;
const VerificationWrapper = styled.div`
  display: grid;
  align-items: center;
  justify-items: center;
`;
const DetailWrapper = styled.div`
  display: grid;
  grid-row-gap: 0.3em;
`;
const PhoneActionWrapper = styled.section`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;
const PhoneWrapper = styled.div`
  i,
  a {
    color: ${baseColors.black};
  }
`;
const ActionWrapper = styled.div`
  display: grid;
  justify-items: end;
`;
const SignInWrapper = styled.section`
  display: grid;
  grid-template-columns: auto auto 1fr;
  grid-column-gap: 1em;
`;
const FullNameWrapper = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-column-gap: 1em;
  a {
    color: ${baseColors.grey};
  }
`;
const QueueWrapper = styled.section``;
const ConfirmModalWrapper = styled.div`
  i {
    cursor: pointer;
  }
`;
const SmallText = styled.span`
  font-size: 0.8em;
  color: ${baseColors.grey};
`;

interface CustomerItemProps {
  customer: Customer;
  onDeleted: () => void;
}

export function CustomerItem(props: CustomerItemProps) {
  const [errorMessage, setErrorMessage] = useState('');
  const customer = props.customer;
  if (!customer) {
    return null;
  }
  const renderCustomerNameRow = customer.fullName || customer.email;
  return (
    <CustomerStyle>
      <VerificationWrapper>
        {(customer.phoneNumberVerified && (
          <Icon name="check square outline" color="green" size="huge" />
        )) || <Icon name="minus square outline" color="red" size="huge" />}
      </VerificationWrapper>
      <DetailWrapper>
        <PhoneActionWrapper>
          <PhoneWrapper>
            <Icon name="phone" size="small" />
            <a href={`tel:${customer.phoneNumber}`}>{customer.phoneNumber}</a>
          </PhoneWrapper>
          <ActionWrapper>
            <ConfirmModalWrapper>
              <ConfirmModal
                buttonText="Delete"
                header={`Delete customer ${customer.phoneNumber}`}
                // content={`Do you realy want to delete customer ${customer.phoneNumber}?`}
                content={
                  !errorMessage
                    ? `Do you realy want to do it?`
                    : ` ${errorMessage}`
                }
                onClose={() => setErrorMessage('')}
                onConfirm={(closeModal) => {
                  (async () => {
                    try {
                      setErrorMessage('');
                      await deleteCustomer(customer.id);
                      props.onDeleted();
                      closeModal();
                    } catch (e) {
                      setErrorMessage('Error while deleting customer!');
                    }
                  })();
                }}
              />
            </ConfirmModalWrapper>
          </ActionWrapper>
        </PhoneActionWrapper>
        {renderCustomerNameRow && (
          <FullNameWrapper>
            {customer.fullName && <span>{customer.fullName}</span>}
            {customer.email && (
              <a href={`mailto:${customer.email}`}>
                <Icon name="mail" size="small" />
                <SmallText>{customer.email}</SmallText>
              </a>
            )}
          </FullNameWrapper>
        )}
        <SignInWrapper>
          <SmallText>Last signed in:</SmallText>
          <TimeAgo date={customer.lastSignIn} />
          <SmallText>
            {dateFormats.short.dateTime(customer.lastSignIn)}
          </SmallText>
        </SignInWrapper>
        <QueueWrapper>
          <div>
            <CustomerQueues queues={customer.queues} />
          </div>
        </QueueWrapper>
        <Consent customer={customer} />
      </DetailWrapper>
    </CustomerStyle>
  );
}
